export const ROLE = {
  0 : '일반 회원',
  11 : '프론트엔드',
  12 : '백엔드',
  13 : '서버',
  21 : '고객지원',
  22 : '인사관리',
}